$(document).ready(function () {
    let blurTimeout = false;
    $('._js-form-fio').on('click',function () {
        $('_js-form-hidden').prop('checked', false);
        $(this).next().addClass('_isActive');
    })

    $('._js-form-input').on('change', function () {
        if ($(this).val() !== '') {
            if (/\d/g.test($(this).val())) {
                $(this).parent('._js-form-fio').addClass('_error');
                return false;
            }
            $(this).attr('data-name',$(this).val());
            $(this).parent('._js-form-fio').removeClass('_error').addClass('_success');
            $('._js-form-text').addClass('onCheck');

            if ($('._js-form-hidden').is(':checked')) {
                let newUrl = new URL($('meta[property="og:image"]').attr('content'));
                newUrl.searchParams.set('U_NAME',$('._js-form-input').val());
                $('meta[property="og:image"]').attr('content', newUrl.href);
            }
        }
    });

    $('._js-form-input').focus(function () {
        if (blurTimeout) clearTimeout(blurTimeout);
        if ($(this).attr('data-name') !== '') {
            console.log('123');
            $(this).val($(this).attr('data-name'));
            $(this).attr('data-name',$(this).val());

        } else {
            $(this).val('');
        }
    })

    // $('._js-form-input').blur(function () {
    //     blurTimeout = setTimeout(() => {
    //         if (!$('._js-form-hidden').is(':checked')) {
    //             $(this).val('');
    //             $('._js-form-label').removeClass('_isActive');
    //             $('._js-form-fio').removeClass('_success');
    //         } else {
    //             $('._js-form-label').removeClass('_isActive');
    //         }
    //     }, 1000);
    // });


    $('._js-form-label').on('click', function (event) {
        if (event.target.className === 'exam-certificate__form-link') {
            $('._js-form-label').removeClass('_isActive');
            return true;
        }
        if ($(this).children('input').is(':checked')) {
            $('._js-form-input').val($('._js-form-input').attr('data-name'));
            $('._js-form-fio').addClass('_success');
            $('._js-form-hidden').prop('checked', false);
            let newUrl = new URL($('meta[property="og:image"]').attr('content'));
            newUrl.searchParams.delete('U_NAME');
            $('meta[property="og:image"]').attr('content', newUrl.href);
        } else {
            setTimeout(function(){
                $('._js-form-hidden').prop('checked', true);
                let newUrl = new URL($('meta[property="og:image"]').attr('content'));
                newUrl.searchParams.set('U_NAME',$('._js-form-input').val());
                $('meta[property="og:image"]').attr('content', newUrl.href);
                $('._js-form-label').removeClass('_isActive');
            }, 100)
        }

    })

});
